import React, { FC } from 'react'
import { Outlet } from 'react-router-dom'

import { EnvContext } from 'modulesCommon/EnvProvider'
import { ScrollToTopButton } from 'components/index'
import { useHeader } from 'modulesCommon/serviceHooks'

import { GlobalProjectTop } from 'modules/GlobalProject/containers/GlobalProjectTop'
import Footer from 'components/Footer/Footer'

import { GHHeader } from '../Header'

export const GHLayout: FC = () => {
  return (
    <EnvContext.Provider value={{ primaryColor: 'primary' }}>
      <Outlet />
    </EnvContext.Provider>
  )
}

export const GHLayoutWrapper: FC = () => {
  const { isLoading, activeArtist } = useHeader()
  return (
    <>
      <GHHeader isLoading={isLoading} activeArtist={activeArtist} />
      <main className="page global-hub-page">
        <Outlet />
        <Footer />
        <ScrollToTopButton />
      </main>
    </>
  )
}

export const GHLayoutProjectWrapper: FC = () => {
  const { isLoading, activeArtist } = useHeader()
  return (
    <>
      <GHHeader isLoading={isLoading} activeArtist={activeArtist} />
      <GlobalProjectTop />
      <main className="page global-hub-page">
        <Outlet />
        <ScrollToTopButton />
      </main>
    </>
  )
}
